<!-- prettier-ignore -->

<div class="route-card">

  @if(tools.isTechMode()){
    <img draggable="false" (click)="removeItem(item)" class="remove-icon" src="/assets/imgs/remove.svg" />
  }

  @if(item?.route_days > 0){
    <div class="days">{{item.route_days}} 
      @if(item?.route_days > 1){
        <span>{{'días' | translate}}</span> 
      }
      @if(item?.route_days === 1){
        <span>{{'día' | translate}}</span> 
      }
    </div>
  }

  <div class="cardImageContainer">
    @if(tools.isApp && !tools.isTechMode()){
      <div (click)="setFavourite(item)" class="love-route-icon">
        <favourite-icon [favourite]="isFavourite(item)" />
      </div>
    }

    <cicerone-lazy-image class="cicerone-lazy-image" 
      (click)="handleClick(item)" 
      [url]="item.image" 
      [urlFallback]="item.imageFallback" 
      [altImage]="item?.name?.[translate.currentLang]" 
    />
  </div>

  <div class="cardInfoContainer">
    <span class="cardText">{{item.name?.[translate.currentLang]}}</span>
    @if(!isSaveRoute){
      <button (click)="handleClick(item)" class="buttonRoutes">{{(!tools.isTechMode() ? 'Usar esta ruta' : 'Modificar esta ruta') | translate}}</button>
    }
    @else{
      <button class="buttonRoutes">{{ 'Usar esta ruta' | translate }}</button>  
    }
  </div>

</div>